import { render, staticRenderFns } from "./MailingTestPopup.vue?vue&type=template&id=70ace8fa&"
import script from "./MailingTestPopup.vue?vue&type=script&lang=js&"
export * from "./MailingTestPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports